export default "/fonts/SofiaSans-700-Bold.woff2?972aab1fbb18da3edf777b45b0afd32e";